import config from "../../config";
import typeOf from "../../helpers/typeOf";

export const getQuery = (query = {}, extra = false) => {
    let params = {};
    const fn = key => {
        key = typeOf.isNumeric(key) ? `param${key + 1}` : key;

        params[key] = query[key] || '';
        query[key] && delete query[key];
    };

    config.metaUtmParams.map(fn);
    Array.from(Array(config.metaParamsCount).keys()).map(fn);

    if (extra) {
        for (let key in query) {
            params[key] = query[key];
        }
    }

    return params;
};
